import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AnalyticsMetricCard from "../AnalyticsMetricCard";
import { getActiveTenant } from "../../../utils/tenantHelpers";
import { fetchScorecard } from "./scorecardAccess";
import { formatUnit } from "./scorecardFormat";
import "./OwnerScorecardCard.css";

/**
 * The Owner scorecard's card on the Analytics landing. Renders NOTHING unless the
 * backend says this tenant has the scorecard — a tenant without it sees no change.
 * Numbers are the scorecard's own live values (same cached response as the sub-nav
 * tab), through scorecardFormat: unknown is "—", never 0.
 */
export default function OwnerScorecardCard() {
  const navigate = useNavigate();
  const [card, setCard] = useState(null);

  useEffect(() => {
    let mounted = true;
    const t = getActiveTenant() || {};
    fetchScorecard(t.id ?? t.tenant_id ?? null).then((d) => { if (mounted) setCard(d); });
    return () => { mounted = false; };
  }, []);

  if (!card?.enabled) return null;
  const m = Object.fromEntries((card.metrics || []).map((x) => [x.key, x]));
  const leads = m.leads_by_source_brand?.detail?.total;
  return (
    <div className="osc-landing-card">
      <AnalyticsMetricCard
        title="Owner scorecard"
        subtitle={`${formatUnit(m.quotes_signed?.value, "count")} quotes signed · close rate ${formatUnit(m.quote_close_rate?.value, "ratio")} · ${formatUnit(m.appointments_next_7d?.value, "count")} booked next 7 days`}
        value={`${formatUnit(leads, "count")} new leads`}
        periodLabel={`last ${card.window_days || 30} days · open the scorecard`}
        onClick={() => navigate("/analytics/scorecard")}
      />
    </div>
  );
}
